import { getSurveysOptions } from "@pulse/api/queryApi";
import ResponseOverviewArea from "@pulse/features/dashboard/ResponseOverview/ResponseOverviewArea";
import { queryClient } from "@pulse/queryClient";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_hub/$customerId/pulse/$pulseId/surveys/$surveyId/")({
    component: RouteComponent,
    staticData: {
        titleFn: (t, params) => {
            const survey = queryClient
                .getQueryData(getSurveysOptions({ pulseInstanceId: +params.pulseId }).queryKey)
                ?.find((s) => s.id === +params.surveyId);

            return survey?.title || t("title.responseOverview");
        },
    },
});

function RouteComponent() {
    const { surveyId } = Route.useParams();

    return <ResponseOverviewArea surveyId={+surveyId} />;
}
